import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, MailIcon, MessageCircleIcon } from 'lucide-react';
import { Button, LinkButton } from '../ui/Button';
import { Input, Select, Textarea } from '../ui/Field';
import { Reveal } from '../ui/Reveal';
import { contact } from '../../data/site';
const interests = ['Seguro de vida', 'Seguro de salud', 'Seguro suplemental', 'Quiero revisar mis opciones', 'No estoy seguro/a'];
export function Appointment() {
  const [submitted, setSubmitted] = useState(false);

  // Ready to be wired to an external scheduler (Calendly, Google Calendar) later.
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <section id="agenda" className="bg-sage py-20 lg:py-32" data-id="element-47" data-mp="2v7nuqj6687od">
      <div className="mx-auto grid max-w-shell gap-12 px-5 lg:grid-cols-[38fr_62fr] lg:gap-16 lg:px-10" data-id="element-48" data-mp="efw1kz014pub">
        <Reveal data-id="element-49" data-mp="aekcqvozc8n6">
          <p className="eyebrow text-navy/60" data-id="element-50" data-mp="af2icixj7z7r">Agenda una cita</p>
          <h2 className="mt-5 font-display text-[2rem] font-semibold leading-[1.15] tracking-[-0.02em] text-navy sm:text-[2.6rem]" data-id="element-51" data-mp="t1zw5180ejn4">
            Hablemos sobre tus opciones.
          </h2>
          <p className="mt-5 max-w-md text-[15px] font-light leading-relaxed text-navy/70" data-id="element-52" data-mp="1237rbaf8b4cz">
            Agenda una conversación conmigo y cuéntame qué tipo de protección estás buscando.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row lg:flex-col lg:items-start" data-id="element-53" data-mp="adcs8m1kk0b4">
            <LinkButton href={contact.whatsapp} target="_blank" rel="noopener noreferrer" variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-54" data-mp="ednb2zagml7e">
              <MessageCircleIcon size={16} strokeWidth={1.6} data-id="element-55" data-mp="o59ggf049q28" />
              WHATSAPP
            </LinkButton>
            <LinkButton href={contact.emailHref} variant="light" size="lg" className="w-full sm:w-auto" data-id="element-56" data-mp="3mrvx1oih8dql">
              <MailIcon size={16} strokeWidth={1.6} data-id="element-57" data-mp="yx9vghajsab9" />
              EMAIL
            </LinkButton>
          </div>

          <p className="mt-8 text-[12.5px] font-light leading-relaxed text-navy/55" data-id="element-58" data-mp="tz84zbasl8pr">
            Al enviar tu solicitud, me pondré en contacto contigo para confirmar la fecha y la
            hora. No compartimos tu información con terceros.
          </p>
        </Reveal>

        <Reveal delay={0.08} data-id="element-59" data-mp="g0qn3u7kiqfr">
          <div className="rounded-[28px] bg-cream p-7 shadow-lift sm:p-10" data-id="element-60" data-mp="g1t9ppxuy6pv">
            {submitted ? <motion.div initial={{
            opacity: 0,
            scale: 0.97
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.3,
            ease: [0.23, 1, 0.32, 1]
          }} role="status" className="flex min-h-[380px] flex-col items-center justify-center text-center" data-id="element-61" data-mp="b2p4fae20t4t">
                <CheckCircle2Icon size={44} strokeWidth={1.1} className="text-teal" data-id="element-62" data-mp="1vh8tb1nbkg34" />
                <h3 className="mt-6 font-display text-[22px] font-semibold text-navy" data-id="element-63" data-mp="23wyfwef4x02y">
                  ¡Gracias!
                </h3>
                <p className="mt-3 max-w-sm text-[14.5px] font-light leading-relaxed text-ink/65" data-id="element-64" data-mp="27zuu7sxn6a13">
                  Recibimos tu solicitud. Me pondré en contacto contigo para confirmar los
                  detalles.
                </p>
                <Button variant="secondary" className="mt-8" onClick={() => setSubmitted(false)} data-id="element-65" data-mp="1z07x3jby3qdu">
                  ENVIAR OTRA SOLICITUD
                </Button>
              </motion.div> : <form onSubmit={handleSubmit} className="grid gap-5 sm:grid-cols-2" data-id="element-66" data-mp="2cxway77lhx9e">
                <Input id="nombre" name="nombre" label="Nombre" placeholder="Tu nombre" required autoComplete="given-name" data-id="element-67" data-mp="2hvobfpmb2rp7" />
                <Input id="apellido" name="apellido" label="Apellido" placeholder="Tu apellido" required autoComplete="family-name" data-id="element-68" data-mp="35kqu90soeqla" />
                <Input id="telefono" name="telefono" type="tel" label="Teléfono" placeholder="(954) 000-0000" required autoComplete="tel" data-id="element-69" data-mp="1ls8saklz0qsm" />
                <Input id="email" name="email" type="email" label="Email" placeholder="tucorreo@email.com" required autoComplete="email" data-id="element-70" data-mp="1hokl43193x7w" />
                <Select id="interes" name="interes" label="¿Qué estás buscando?" options={interests} placeholder="Selecciona una opción" required className="sm:col-span-2" data-id="element-71" data-mp="17ry1fhknvc7g" />
                <Textarea id="mensaje" name="mensaje" label="Cuéntame brevemente qué necesitas" placeholder="Escribe aquí…" className="sm:col-span-2" data-id="element-72" data-mp="1vpdgepzdmwc2" />
                <Input id="fecha" name="fecha" type="date" label="Fecha preferida" data-id="element-73" data-mp="2o8aorl81a4f5" />
                <Input id="hora" name="hora" type="time" label="Hora preferida" data-id="element-74" data-mp="2jdwrfd9t9n7u" />
                <Button type="submit" size="lg" fullWidth className="sm:col-span-2 mt-1" data-id="element-75" data-mp="2qrp4x49al1fz">
                  SOLICITAR CITA
                </Button>
              </form>}
          </div>
        </Reveal>
      </div>
    </section>;
}